import { render, staticRenderFns } from "./Placement.vue?vue&type=template&id=347a8556&scoped=true&"
import script from "./Placement.vue?vue&type=script&lang=js&"
export * from "./Placement.vue?vue&type=script&lang=js&"
import style0 from "./Placement.vue?vue&type=style&index=0&id=347a8556&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a8556",
  null
  
)

export default component.exports